import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { Hedging } from '@fortem-monorepo/web-sdk'

import { toastApiError } from '@/lib/error-toast'

export const useUpdateHedgingEntryMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Hedging.UpdateHedgingBody) => api.hedging.updateHedging(body),
    onSuccess: (_data, params) => {
      toast.success(`Successfully updated ${params.oldValue} to ${params.newValue}`)
    },
    onError: (error, params) => {
      toastApiError(error, `Error updating ${params.oldValue} to ${params.newValue}`)
    },
  })
}

export const useResetHedgingEntryMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (params: Hedging.ResetHedgingEntryParams) => api.hedging.resetHedgingRow(params),
    onSuccess: (_data, params) => {
      toast.success(`Successfully reset entry ${params.deal_reference}`)
    },
    onError: (error, params) => {
      toastApiError(error, `Error resetting entry ${params.deal_reference}`)
    },
  })
}

export const useBookHedgingMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Hedging.BookHedgingFwdBody) => api.hedging.bookHedging(body),
    onSuccess: (_data, params) => {
      const fund_string = params.fund_name ? ` for fund ${params.fund_name}` : ''
      toast.success(`Successfully booked trades on ${params.value_date}${fund_string}`)
    },
    onError: (error, params) => {
      const fund_string = params.fund_name ? ` for fund ${params.fund_name}` : ''
      toastApiError(error, `Error booking trades on ${params.value_date}${fund_string}`)
    },
  })
}

export const useUnwindMaturingMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Hedging.UnwindMaturingFwdBody) => api.hedging.unwindMaturing(body),
    onSuccess: (_data, params) => {
      const fund_string = params.fund_name ? ` for fund ${params.fund_name}` : ''
      toast.success(`Successfully unwound trades on ${params.value_date}${fund_string}`)
    },
    onError: (error, params) => {
      const fund_string = params.fund_name ? ` for fund ${params.fund_name}` : ''
      toastApiError(error, `Error unwinding trades on ${params.value_date}${fund_string}`)
    },
  })
}
